import * as React from 'react';
import {CSSProperties} from 'react';
import {Icon} from "antd";
import {Item} from "../api/dtos/dtos";
import locales from "../locales";

const containerStyle: CSSProperties = {
  display: "flex",
  flexWrap: "wrap",
  alignItems: "center",
};

const iconStyle: CSSProperties = {
  // Note: this changes the internal svg icon size as well
  fontSize: 16,
  color: '#f04134'
};

export const renderItemName = (item: Item): React.ReactNode => {
  return renderItemNameWithMaintenanceIcon(item.name!, item.inMaintenance!);
};

export const renderItemNameWithMaintenanceIcon = (name: string, inMaintenance: boolean) => {
  return inMaintenance
    ? (
      <div style={containerStyle}>
        <span>
          {name}
          &nbsp;&nbsp;
          {renderMaintenanceIcon(inMaintenance)}
        </span>
      </div>
    )
    : name;
};

export const renderMaintenanceIcon = (inMaintenance: boolean) => {
  return inMaintenance
    ? <Icon type="tool" theme="filled" style={iconStyle} title={locales.item_in_maintenance}/>
    : <div/>
}


// WEBPACK FOOTER //
// ./src/item/item-name-renderer.tsx